export default {
    recoveryPassword: 'Recuperar contraseña',
    login: 'Iniciar sesión',
    loginWithGoogle: 'Iniciar sesión con Google',
    loginWithOutlook: 'Iniciar sesión con Outlook',
    notAccount: '¿No tienes cuenta?',
    notAccountRegister: 'Regístrate',
    requestAccount: 'Solicita una aquí',
    requestAccountMessage: 'Hola, quiero solicitar una cuenta en Keru.',
    loginError: 'Ha ocurrido un error al iniciar sesión',
    resetPasswordError: 'Ha ocurrido un error al reestablecer la contraseña:',
    validateEmail: 'Verifica el email ingresado e intenta nuevamente',
    invalidEmail: 'Debes ingresar un email válido para continuar',
    nextStep: 'Siguiente',
    changeEmail: 'Cambiar correo',
    invalidCredentials: 'Credenciales no válidas. Por favor verifica nuevamente',
    MF2field: 'Ingresa el código de autenticación',
    rememberMF2: 'Recordar código de autenticación',
    mf2CodeRequired: 'Debes ingresar el código de autenticación',
    notConfirmedAccount: 'Aún no has confirmado tu cuenta, te enviaremos un correo electrónico a continuación',
    confirmAccount: 'Confirma tu cuenta',

};
